import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { websitePlanService } from "../../service/websitePlanService";

const PaidServiceFormModal = ({ show, onHide, onSubmit, initialData }) => {
  const [formData, setFormData] = useState({
    name: "",
    website_plan: "",
    amount: "",
    discount: "",
    optional1: "",
    optional2: "",
    description: "",
    status: true,
  });

  const [plans, setPlans] = useState([]);
  const [plansLoading, setPlansLoading] = useState(false);

  useEffect(() => {
    const fetchPlans = async () => {
      setPlansLoading(true);
      try {
        const res = await websitePlanService.getAll();
        if (res?.data && Array.isArray(res.data)) {
          setPlans(res.data);
        }
      } catch (e) {
        console.warn("Failed to fetch plans for modal:", e);
      } finally {
        setPlansLoading(false);
      }
    };
    if (show) {
      fetchPlans();
    }
  }, [show]);

  useEffect(() => {
    if (initialData) {
      setFormData({
        id: initialData.id,
        name: initialData.name || "",
        website_plan: initialData.website_plan || initialData.website_plan_id || "",
        amount: initialData.amount || initialData.base_amount || "",
        discount: initialData.discount || "",
        optional1: initialData.optional1 || initialData.optional_1 || "",
        optional2: initialData.optional2 || initialData.optional_2 || "",
        description: initialData.description || "",
        status: initialData.status !== undefined ? String(initialData.status) === "true" || initialData.status === true : true,
      });
    } else {
      setFormData({
        name: "",
        website_plan: "",
        amount: "",
        discount: "",
        optional1: "",
        optional2: "",
        description: "",
        status: true,
      });
    }
  }, [initialData, show]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static" size="lg" data-bs-theme="light">
      <Modal.Header closeButton className="bg-primary text-white py-3">
        <Modal.Title className="fs-5 text-white m-0">
          {initialData ? "Edit Paid Service" : "Add New Paid Service"}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body className="p-4">
          <Row className="g-3">
            <Col md={6}>
              <Form.Group controlId="serviceName">
                <Form.Label className="fw-semibold">
                  Service Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter service name (e.g. SSL Certificate)"
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="websitePlan">
                <Form.Label className="fw-semibold">
                  Target Website Plan <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  name="website_plan"
                  value={formData.website_plan}
                  onChange={handleChange}
                  required
                  disabled={plansLoading}
                >
                  <option value="">-- Select Website Plan --</option>
                  {plans.map((p) => (
                    <option key={p.id} value={p.id}>
                      {p.plan_name} {p.duration ? `(${p.duration} Months)` : ""}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="amount">
                <Form.Label className="fw-semibold">
                  Amount (₹) <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  placeholder="0.00"
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="discount">
                <Form.Label className="fw-semibold">Discount (%)</Form.Label>
                <Form.Control
                  type="number"
                  step="0.1"
                  min="0"
                  max="100"
                  name="discount"
                  value={formData.discount}
                  onChange={handleChange}
                  placeholder="0"
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="optional1">
                <Form.Label className="fw-semibold">Optional Field 1</Form.Label>
                <Form.Control
                  type="text"
                  name="optional1"
                  value={formData.optional1}
                  onChange={handleChange}
                  placeholder="Additional note / extra parameter 1"
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="optional2">
                <Form.Label className="fw-semibold">Optional Field 2</Form.Label>
                <Form.Control
                  type="text"
                  name="optional2"
                  value={formData.optional2}
                  onChange={handleChange}
                  placeholder="Additional note / extra parameter 2"
                />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group controlId="description">
                <Form.Label className="fw-semibold">Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Detailed description of the service..."
                />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Check
                type="switch"
                id="status-switch"
                label="Service Status (Active)"
                name="status"
                checked={formData.status}
                onChange={handleChange}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="bg-light px-4 py-3">
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            {initialData ? "Update Service" : "Create Service"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default PaidServiceFormModal;
